import * as yup from 'yup';
import * as regex from '../../../utils/constants/regex';

export const companyDetailsFormSchema = yup.object({
  email: yup
    .string()
    .matches(regex.EMAIL, 'Please enter a valid email')
    .required('Company email is required'),
  companyName: yup
    .string()
    .required('Company name is required'),
  mobile: yup
    .string()

    .length(10, 'Please enter valid number')
    .matches(
      regex.MOBILE_NUMBER,
      'Please enter valid number'
    )
    .required(),

  sellerType: yup.string(),
  pinCode: yup
    .string()
    .required('Pin Code is required')

    .length(6, 'PinCode should be 6 characters'),
  stateId: yup.string().nullable(),
  state: yup.string().required('State is required'),
  stateName: yup.string().nullable(),
  district: yup.string(),
  districtName: yup.string().nullable(),
  districtServerId: yup.string(),
  districtId: yup.string().nullable(),

  addressType: yup.string(),
  tehsil: yup.string(),
  tehsilName: yup.string().nullable(),
  tehsilId: yup.string().nullable(),
  tehsilServerId: yup.string(),
  village: yup.string(),
  villageName: yup.string().nullable(),
  villageId: yup.string().nullable(),
  villageServerId: yup.string(),
  address: yup
    .string()
    .max(255, 'address should be maximum 255 characters'),
  manualDistrict: yup
    .string()
    .when(
      'districtServerId',
      ([districtServerId], schema) => {
        return districtServerId == -1
          ? schema.max(20)
          : schema;
      }
    )
    .nullable(),
  manualTehsil: yup
    .string()
    .when('tehsilServerId', ([tehsilServerId], schema) => {
      return tehsilServerId == -1 ? schema.max(20) : schema;
    })
    .nullable(),
  manualVillage: yup
    .string()
    .when(
      'villageServerId',
      ([villageServerId], schema) => {
        return villageServerId == -1
          ? schema.max(20)
          : schema;
      }
    )
    .nullable(),
  gstNumber: yup
    .string()
    .transform((value) =>
      value === '' ? undefined : value
    )
    .nullable()
    .length(15, 'GST number should be 15 characters')
    .matches(
      regex.GST_REGEX,
      'Please enter valid GST number'
    ),
  panNumber: yup
    .string()
    .length(10, 'PAN number should be 10 characters')
    .matches(
      regex.PAN_NUMBER_REGEX,
      'Please enter valid PAN card number'
    ),
  bankName: yup.string(),
  bankAccountNumber: yup.string(),
  accountHolderName: yup.string(),
  ifscCode: yup
    .string()
    .matches(regex.IFSC_REGEX, 'IFSC code should be valid')
    .length(11, 'IFSC code should be 11 characters'),
  razorpayAccountId: yup.string(),
  tds: yup.string(),
  tcs: yup.string(),
  companyType: yup.string(),
  sapSync: yup.string(),
  productCategory: yup.array(yup.string().required()),
  uploadedPanFile: yup.object({
    shortUrl: yup
      .string()
      .required('Please upload PAN card'),
    url: yup.string().required('Please upload PAN card'),
  }),
  uploadedCancelChequeFile: yup.object({
    shortUrl: yup
      .string()
      .required('Please upload Canceled Cheque'),
    url: yup
      .string()
      .required('Please upload Canceled Cheque'),
  }),
  uploadedGstFile: yup.object({
    shortUrl: yup.string(),
    url: yup.string(),
  }),
  uploadedCompanyFile: yup.object({
    shortUrl: yup
      .string()
      .required('Please upload  company logo document'),
    url: yup
      .string()
      .required('Please upload  company logo document'),
  }),
  originalAgreementSignedBy: yup.number(),
  originalAgreementSignedDate: yup.date(),
});

export type TCompanyDetailsFormData = yup.InferType<
  typeof companyDetailsFormSchema
>;
